














import { Component, Vue } from "vue-property-decorator";

@Component
export default class Snackbar extends Vue {
  private display = false;
  private text = "";
  private timeout = 8000;
  private color = "blue";

  created() {
    this.$root.$on(
      "snackbar-message",
      (message: { text: string; color: string }) => {
        this.text = message.text;
        this.display = true;
        this.color = message.color;
      }
    );
  }
}
